import * as React from 'react'
import { createIcon } from './createIcon'
import { IconOptions } from './icon-options'

function IconContent({ color }: IconOptions) {
  return (
    <React.Fragment>
      <rect x='16' y='18' width='17' height='2' fill={color} />
      <rect x='18.5' y='16.5' width='12' height='16' rx='1.5' stroke={color} />
      <rect x='21' y='28' width='6' height='1' transform='rotate(-90 21 28)' fill={color} />
      <rect x='24' y='28' width='6' height='1' transform='rotate(-90 24 28)' fill={color} />
      <rect x='27' y='28' width='6' height='1' transform='rotate(-90 27 28)' fill={color} />
      <rect x='19' y='17' width='11' height='1' fill={color} />
    </React.Fragment>
  )
}

export const DeleteIcon = createIcon(IconContent, { resourceSize: 48 })
